import React, { useState, useEffect, useRef } from 'react';

import { NavLink, useParams } from 'react-router-dom';

import { createBuildSheet, getCarDetail } from '../../api/cars';

import { useCarsState } from '../../providers/CarsProvider';

import Option from '../Option';

import OptionCategory from '../OptionCategory';

import { gsap } from "gsap";

import { hexToRgb, downloadFile, srgbToLinear } from '../../helpers/utils';

import ConfigurationsModule from '../ConfigurationsModule';

import TimesIcon from '../icons/TimesIcon';

import AbstractScreen from './AbstractScreen';

import UsersModule from '../UsersModule';

import ArrowRightFromLineIcon from '../icons/ArrowRightFromLineIcon';

import GlobeIcon from '../icons/GlobeIcon';

// import { ChromePicker } from 'react-color';

import ReactCrop from 'react-image-crop';

import 'react-image-crop/dist/ReactCrop.css';

import CheckIcon from '../icons/CheckIcon';

import BarsIcon from '../icons/BarsIcon';

import FileArrowDownIcon from '../icons/FileArrowDownIcon';

import CameraViewfinderIcon from '../icons/CameraViewfinderIcon';

import { validateDepenencies } from '../../helpers/cars';

import Switch from "react-switch";

const fov_ref = { angle: 45 };

const CarDetailScreen = () => {

    const [ configurationsEnabled, setConfigurationsEnabled ] = useState( false );

    const { carIdOrSlug } = useParams();

    const [ carId, setCarId ] = useState( { id:null } );

    const [ state, setState ] = useState( { id:null } );

    const [ sendBuildTo, setSendBuildTo ] = useState();

    const [ allowDownload, setAllowDownload ] = useState();

    const [ crop, setCrop ] = useState( {
            unit: '%',
            x: 25,
            y: 25,
            width: 50,
            height: 50
    });

    const [ carsState, carsDispatch ] = useCarsState();

    const [ anonymousUser, setAnonymousUser ] = useState();

    const [ api, setApi ] = useState()

    const [ ready, setReady ] = useState( false );

    const [ modelLoadProgress, setModelLoadProgress ] = useState( 0 );

    const [ textureLoadProgress, setTextureLoadProgress ] = useState( 0 );

    const [ totalLoadProgress, setTotalLoadProgress ] = useState( 0 );

    const [ fov, setFOV ] = useState( fov_ref );

    const [ cameraViews, setCameraViews ] = useState( {} );

    const [ currentCameraView, setCurrentCameraView ] = useState();

    const [ defaultHiddenNodes, setDefaultHiddenNodes ] = useState([]);

    const [ mobileOnlyNodes, setMobileOnlyNodes ] = useState([]);

    const [ desktopOnlyNodes, setDesktopOnlyNodes ] = useState([]);

    const [ environmentNodes, setEnvironmentNodes ] = useState();

    const [ showEnvironment, setShowEnvironment ] = useState( true );

    // const [ bodyColorTestValue, setBodyColorTestValue ] = useState();

    const [ navigationOpen, setNavigationOpen ] = useState( window.isMobile ? false : true );

    const [ configurationsOpen, setConfigurationsOpen ] = useState( false );

    const currentMaterialsList = useRef({});

    const crop_canvas_ref = useRef();

    const start_open = useRef( false );

    const [ hd, setHd ] = useState( null );

    let currentHideNodes = [];

    let currentShowNodes = [];

    const [ colors, setColors ] = useState( { "primary": "#ed6463", "secondary": "#bacbd0", "accent": "#70b587", "background":"#000000" } );

    useEffect( () => {

        if( api ){

            let _is_hd = ( hd == true && !window.isMobile );
    
            if( hd !== null ){
                    
                api.setTextureQuality( _is_hd ? 'hd' : 'sd', function(err) {
                    if (!err) {
                        console.log('Texture quality set to high definition');
                    } else {
                        console.log( err )
                    }
                } );
            }
    
            if( _is_hd ){
    
                if( desktopOnlyNodes ) desktopOnlyNodes.forEach( node_name => { showNodeByName( node_name, true ); } );
    
                if( mobileOnlyNodes ) mobileOnlyNodes.forEach( node_name => { hideNodeByName( node_name, true ); } );
            } else {
    
                if( desktopOnlyNodes ) desktopOnlyNodes.forEach( node_name => { hideNodeByName( node_name, true ); } );
    
                if( mobileOnlyNodes ) mobileOnlyNodes.forEach( node_name => { showNodeByName( node_name, true ); } ); 
            }
        }
    } , [ hd ] )

    useEffect( () => {

        if( api && ready ){

            if( showEnvironment ){

                environmentNodes.forEach( node_name => {

                    showNodeByName( node_name, true );
                } )
            } else {

                environmentNodes.forEach( node_name => {

                    hideNodeByName( node_name, true );
                } )
            }
        }

    }, [ showEnvironment ] )

    const toCameraView = ( cameraView, speed ) => {

        console.log( "toCameraView", cameraView, currentCameraView );

        if( currentCameraView != cameraView ){

            api.setUserInteraction( false );
    
            api.setEnableCameraConstraints( false );
    
            api.setCameraLookAtEndAnimationCallback( () => {
    
                api.setEnableCameraConstraints( true );
    
                api.setCameraConstraints( cameraView.constraints )
    
                api.setUserInteraction( true );
            })
    
            api.setCameraLookAt( cameraView.camera_position, cameraView.target_position, speed );
    
            initChangeFOV( cameraView.pov, speed );

            setCurrentCameraView( cameraView )
        }
    }

    const initChangeFOV = ( a, speed ) => {

        gsap.to( fov_ref, { ease: "power4.inOut", angle: a, onUpdate: () => {

            setFOV( fov_ref.angle );
        }, duration: speed } )
    }

    const getTextureUidByName = texture_name => {

        let texture = carsState.texturesList.find( t => t.name == texture_name );

        if( texture ) return texture.uid

        return null;
    }

    const setChangedOption = ( option_value ) => {

        if( option_value.hide ) option_value.hide.forEach( node_name => hideNodeByName( node_name, true ) );

        if( option_value.show ) option_value.show.forEach( node_name => showNodeByName( node_name, true ) );

        if( option_value.translate ) {

            option_value.translate.forEach( node => transformNodeByName( node.name, node.x, node.y, node.z ) )
        }

        if( option_value.type == "custom_texture_upload" && option_value.material && option_value.imageData ){

            api.addTexture( option_value.imageData , function( err, textureUid ) {
                
                if (!err) {

                    let _mat = carsState.materialsList.find( m => m.name == option_value.material );

                    _mat = JSON.parse( JSON.stringify( _mat ) );

                    _mat.channels.AlbedoPBR.texture.uid = textureUid;

                    _mat.channels.AlphaMask.texture.uid = textureUid;

                    _mat.channels.AlphaMask.factor = .05;

                    api.setMaterial( _mat );

                }
            });
        }

        if( option_value.materials ) {

            option_value.materials.forEach( material => {

                let _mat = null;

                if( currentMaterialsList.current[ material.name ] ){

                    _mat = currentMaterialsList.current[ material.name ];
                } else {

                    _mat = carsState.materialsList.find( m => m.name == material.name );
                }

                if( _mat ){

                    _mat = JSON.parse( JSON.stringify( _mat ) );

                    let new_material = { ..._mat }

                    if( material.match ){

                        let _ref_mat = carsState.materialsList.find( m => m.name == material.match );                        

                        if( _ref_mat ){

                            _ref_mat = JSON.parse( JSON.stringify( _ref_mat ) );

                            let _channels = JSON.parse( JSON.stringify( _ref_mat.channels ) );

                            new_material = { ..._mat, channels: _channels }

                        } else {

                            console.log( "ref material not found", material.match );
                        }
                    }

                    if( material.channels ){

                        let channels = JSON.parse( JSON.stringify( new_material.channels ) )

                        Object.keys( material.channels ).forEach( channel_name => {

                            Object.keys( material.channels[ channel_name ] ).forEach( channel_value_name => {

                                if( channel_value_name == "texture" ){

                                    let texture_uid = getTextureUidByName( material.channels[ channel_name ][ channel_value_name ] );

                                    if( channels[ channel_name ].texture && channels[ channel_name ].texture.uid )

                                        channels[ channel_name ].texture.uid = texture_uid;

                                    console.log( channels[ channel_name ] );

                                } else {

                                    let _v = JSON.parse( JSON.stringify( material.channels[ channel_name ][ channel_value_name ] ) );

                                    if( _v.ref ){

                                        if( _v.ref.group ){

                                            let _ref_v = JSON.parse( JSON.stringify( carsState.currentConfiguration[ _v.ref.group ].value ) );

                                            _v = _ref_v[ _v.ref.key ];
                                        }
                                    }

                                    if ( typeof _v === 'string' || _v instanceof String ){

                                        if( _v.indexOf( "#" ) !== -1 ){

                                            _v = hexToRgb( _v )
                                        }
                                    }

                                    if( Array.isArray( _v ) ){

                                        for( let vi = 0; vi < _v.length; vi++ ) {

                                            _v[ vi ] = srgbToLinear(  _v[ vi ] / 255 );
                                        }
                                    }

                                    channels[ channel_name ][ channel_value_name ] = _v;
                                }

                            } )
                        } );

                        new_material = { ..._mat, channels }

                    } else {

                        console.log("material not found", material );
                    }

                    let new_list = { ...currentMaterialsList.current }

                    new_list[ new_material.name ] = new_material;

                    currentMaterialsList.current = new_list;

                    api.setMaterial( new_material );
                }
            } )
        }
    }

    const onOptionChange = ( option_value ) => {

        if( option_value ){

            if( Array.isArray( option_value ) ){
    
                option_value.forEach( v => setChangedOption( v.value ) )
            } else{
    
                setChangedOption( option_value.value )
            }
    
            // if( window.isMobile ) setNavigationOpen( false );
        }
    }

    const hideNodeByName = ( node_name, settingDefaultVisibility ) => {

        let _node = { ...carsState.nodesList.find( n => n.name == node_name ) };

        if( !settingDefaultVisibility )

            currentHideNodes = [ ...currentHideNodes,  _node.instanceID ]

        hideNodeById( _node.instanceID );
    }

    const showNodeById = ID => {

        api.show( ID, function( err ) { if(err) console.log( err ) } );
    }

    const hideNodeById = ID => {

        api.hide( ID, function( err ) { if(err) console.log( err ) } );
    }

    const showNodeByName = ( node_name, settingDefaultVisibility ) => {

        let _node = { ...carsState.nodesList.find( n => n.name == node_name ) };

        if( !settingDefaultVisibility )

            currentShowNodes = [ ...currentShowNodes,  _node.instanceID ];

        showNodeById( _node.instanceID )
    }

    const transformNodeByName = ( node_name, x, y, z ) => {

        let _node = { ...carsState.nodesList.find( n => n.name == node_name ) };

        api.translate( _node.instanceID, [ x || 0, y || 0, z || 0 ] )
    }

    const setDefaultConfiguration = ( option_categories ) => {

        let data = {};

        option_categories.forEach( category => {

            category.groups.forEach( group => {

                if( !data[ group.slug ] )

                    data[ group.slug ] = group.select_multiple_options ? [] : group.options[ 0 ];

                if( data[ group.slug ] ) 
                    
                    data[ group.slug ].group_label = group.label;
            } );
        } );

        carsDispatch( { type: 'setCurrentConfiguration', id: Date.now(), data } )
    }

    useEffect( () => {

        if( carsState.carDetails[ carId ] ){

            setState( { ...carsState.carDetails[ carId ] } );
        }

    }, [ carsState.carDetails[ carId ] ] )


    // useEffect( () => {

    //     if( bodyColorTestValue ){

    //         const value = {
    //             materials: [
    //                 {
    //                     name: "carpaint-default",
    //                     channels: {
    //                         AlbedoPBR: {
    //                             color: [
    //                                 bodyColorTestValue.rgb.r,
    //                                 bodyColorTestValue.rgb.g,
    //                                 bodyColorTestValue.rgb.b
    //                             ],
    //                             factor: 1
    //                         },
    //                         ClearCoat: {
    //                             tint: [ 
    //                                 bodyColorTestValue.rgb.r,
    //                                 bodyColorTestValue.rgb.g,
    //                                 bodyColorTestValue.rgb.b
    //                             ],
    //                             factor: 0.8,
    //                             reflectivity: 0.4,
    //                             thickness: 2
    //                         },
    //                         MetalnessPBR: {
    //                             factor: 0.3
    //                         },
    //                         SpecularF0:{
    //                             factor: 0.2
    //                         }
    //                     }
    //                 }
    //             ]
    //         }

    //         setChangedOption( value )
    //     }

    // }, [ bodyColorTestValue ] )


    const resetCurrentNodes = () => {

        currentHideNodes.forEach( nodeId => {

            showNodeById( nodeId );
        });

        currentHideNodes = []

        currentShowNodes.forEach( nodeId => {

            hideNodeById( nodeId );
        })

        currentShowNodes = [];

        defaultHiddenNodes.forEach( node_name => {

            hideNodeByName( node_name, true );
        } );

        let _is_hd = ( hd == true && !window.isMobile );

        if( _is_hd ){

            if( desktopOnlyNodes ) desktopOnlyNodes.forEach( node_name => { showNodeByName( node_name, true ); } );

            if( mobileOnlyNodes ) mobileOnlyNodes.forEach( node_name => { hideNodeByName( node_name, true ); } );
        } else {

            if( desktopOnlyNodes ) desktopOnlyNodes.forEach( node_name => { hideNodeByName( node_name, true ); } );

            if( mobileOnlyNodes ) mobileOnlyNodes.forEach( node_name => { showNodeByName( node_name, true ); } ); 
        }
    }

    useEffect( () => {

        resetCurrentNodes();

        Object.keys( carsState.currentConfiguration ).forEach( group_slug => {

            if( group_slug !== "id" ){

                let group_value = null

                state.option_categories.forEach( category => {
                    
                    category.groups.forEach( group => {

                        if( group.slug == group_slug ){
                            
                            group_value = { ...group };
                        }
                    } );
                } );

                let valid = true;
                
                if( group_value && group_value.data && group_value.data.dependencies ) {

                    valid = validateDepenencies( carsState.currentConfiguration, group_value.data.dependencies );
                }

                console.log( "group" ,group_value, valid );

                if( valid )onOptionChange( carsState.currentConfiguration[ group_slug ] );
            }
        } );

    }, [ carsState.currentConfiguration ] )

    useEffect( () => {

        setTotalLoadProgress( Math.ceil( ( ( textureLoadProgress + modelLoadProgress ) / 2 ) * 100 ) );

    }, [ modelLoadProgress, textureLoadProgress ] )

    useEffect( () => {

        if( !ready && totalLoadProgress == 100 ){

            setReady( true );

            setTimeout( () => {

                setHd( false );

            } , 1000 )
        }

    }, [ totalLoadProgress ] )

    useEffect( () => {

        console.log("selectedgroupchanged:", carsState.selectedGroup)

        if( carsState.selectedGroup && api && ready ){

            if( carsState.selectedGroup.data && carsState.selectedGroup.data.camera_view && cameraViews[ carsState.selectedGroup.data.camera_view ] ){

                toCameraView( cameraViews[ carsState.selectedGroup.data.camera_view ], 2 );
            }
        }

    }, [ carsState.selectedGroup ] )

    useEffect( () => {

        console.log( "selectedoptionchanged:", carsState.selectedOption )

        if( carsState.selectedOption && api && ready ){

            console.log( "selectedOption", carsState.selectedOption )

            if( carsState.selectedOption.value && carsState.selectedOption.value.camera_view && cameraViews[ carsState.selectedOption.value.camera_view ] ){

                toCameraView( cameraViews[ carsState.selectedOption.value.camera_view ], 2 );
            }
        }

    }, [ carsState.selectedOption ] )

    useEffect(()=>{
        console.log("crop changed", crop)
    },[crop])

    useEffect( () => {

        if( ready && api ){

            api.setEnableCameraConstraints( true );

            defaultHiddenNodes.forEach( node_name => {

                hideNodeByName( node_name, true );
            });

            setFOV( fov_ref.angle );

            api.setCameraEasing( "easeInOutQuintic" );

            toCameraView( cameraViews[ 'exterior' ] || cameraViews[ 'body' ], 0 );

            if( state.option_categories ) setDefaultConfiguration( state.option_categories );

            if( start_open.current == true && state.option_categories && state.option_categories.length > 0 ){

                carsDispatch( { type:'setSelectedCategory', data: state.option_categories[ 0 ] } );
            }
        }

    }, [ ready ] )

    useEffect( () => {

        if( api && ready ){

            api.setFov( fov );
        }
    }, [ fov ] )

    useEffect( () => {

        getCarDetail( carIdOrSlug ).then( data => {

            setCarId( data.id )

            if( data.sketchfab_configuration && data.sketchfab_configuration.colors ){

                setColors( data.sketchfab_configuration.colors );
            }

            setConfigurationsEnabled( data.userid && !data.is_staff );

            setAnonymousUser( !data.userid );

            carsDispatch( { type: "updateCar", data } );

            var iframe = document.getElementById( "api-frame" );

            var uid = data.sketchfab_configuration.id || null;

            start_open.current = data.sketchfab_configuration.start_open || false;

            var client = new window.Sketchfab( iframe );

            setCameraViews( data.sketchfab_configuration.cameraViews );

            if( data.sketchfab_configuration.hiddenNodes )

                setDefaultHiddenNodes( data.sketchfab_configuration.hiddenNodes );

            if( data.sketchfab_configuration.mobileOnlyNodes )

                setMobileOnlyNodes( data.sketchfab_configuration.mobileOnlyNodes );

            if( data.sketchfab_configuration.desktopOnlyNodes )

                setDesktopOnlyNodes( data.sketchfab_configuration.desktopOnlyNodes );

            if( data.sketchfab_configuration.environmentNodes )

                setEnvironmentNodes( data.sketchfab_configuration.environmentNodes );

            if( data.sketchfab_configuration.allow_download )

                setAllowDownload( data.sketchfab_configuration.allow_download );

            if( data.sketchfab_configuration.send_build_to )

                setSendBuildTo( data.sketchfab_configuration.send_build_to );

            if( client && uid ){

                client.init( uid, {
                    ui_inspector:0,
                    ui_help:0,
                    ui_hint:0,
                    ui_watermark:0,
                    ui_start:0,
                    ui_infos:0,
                    ui_stop:0,
                    ui_vr:0,
                    ui_fullscreen:0,
                    dof_circle:0,
                    ui_general_controls: 0,
                    camera:0,
                    max_texture_size: 16384,
                    autostart:1,
                    animation_autoplay:0,
                    success: function onSuccess( _api ){

                        setApi( _api );

                        window.api = _api;

                        _api.start();

                        _api.addEventListener( "camerastop", function() {

                            _api.getCameraLookAt(function(err, camera) {

                                console.log(camera.position);

                                console.log(camera.target);
                            });
                        });

                        _api.addEventListener( "modelLoadProgress", function (eventData) {

                            setModelLoadProgress( eventData.progress );

                            console.log( eventData.progress )
                        });

                        _api.addEventListener( "textureLoadProgress", function (eventData) {

                            setTextureLoadProgress( eventData.progress );
                        });

                        _api.addEventListener( "viewerready", function() {

                            _api.getNodeMap(function(err, _nodes) {

                                if( !err ) {

                                    let nodes = [];

                                    Object.keys( _nodes ).forEach( _k => nodes.push( _nodes[ _k ] ) );

                                    carsDispatch( { type: "setNodesList", nodes } );

                                    _api.getSceneGraph( function( err, graph ) {

                                        if( !err ) {

                                            console.log( "graph", graph );

                                            _api.getMaterialList( function( err, materials ) {

                                                if( !err ) {

                                                    console.log( "materials", materials );

                                                    carsDispatch( { type: "setMaterialsList", materials } );

                                                    _api.getTextureList( function( err, textures ) {

                                                        carsDispatch( { type: "setTexturesList", textures } );

                                                        textures.forEach( element => {

                                                            console.log( element.name );
                                                        });

                                                        if( !err ) {

                                                            console.log( "textures", textures );
                                                        }
                                                    });
                                                } else {

                                                    console.error( err );
                                                }
                                            });
                                        } else {

                                            console.error( err );
                                        }
                                    });
                                } else {

                                    console.error( err );
                                }
                            } );
                        } )
                    },
                    error: function onError() {

                        console.log( 'Viewer error' );
                    }
                } )
            }
        } )
    }, [] )

    useEffect( () => {

        if( configurationsOpen && window.isMobile ) setNavigationOpen( false );

    },[ configurationsOpen ] )

    useEffect( () => {

        if( navigationOpen && window.isMobile ) setConfigurationsOpen( false );

    },[ navigationOpen ] )

    return(
        <AbstractScreen id={ 'product-detail cover' } className="pos-rel" style={ { background: colors['background'] } }>
            <div className="cover" >
                {/* <div className="pos-fixed z-5 overflow-y-auto p-2" style={{ maxHeight:'100%', maxWidth:'calc( 100% - 400px )', top:0, right:0}}>
                    <div className="d-flex flex-wrap align-items-start" style={{gap:20}}>
                        <div className="d-flex flex-column rounded-4 p-1" style={{display:'none', background:"#ffffff66", gap:5}}>
                            <h6>Body Color</h6>
                            <ChromePicker width={200}
                                color={ bodyColorTestValue }
                                disableAlpha={ true }
                                onChangeComplete={ ( _color ) => {
                                    setBodyColorTestValue( _color )
                                }}
                            />
                        </div>
                    </div>
                </div> */}
                <div className="pos-fixed text-white z-1 bold d-flex h5" style={{ gap:10, display: ready ? 'flex' : 'none', bottom: 10, right: "50%", transform:'translateX(-50%)' }}>
                    
                    { environmentNodes && <button className="d-flex align-items-center rounded-4" style={{padding:8, gap:10, background: "#99999966", opacity: showEnvironment ? 1 : .5}} onClick={ () => setShowEnvironment( !showEnvironment ) }><GlobeIcon /></button> }
                    <button className="d-flex align-items-center rounded-4" style={{ padding:8, gap:10, background: "#99999966" }} onClick={ () => {
6
                        if( api ) api.getScreenShot( 1080, 1080, 'image/jpeg', ( error, image ) => {

                            downloadFile( image, 'screenshot' + Date.now() + '.jpeg' )
                        } )
                    }}><CameraViewfinderIcon /></button>
                    { !anonymousUser && <a href="/logout" className="d-flex align-items-center rounded-4" style={{ padding:8, gap:10, background: "#99999966" }} ><ArrowRightFromLineIcon /></a> }
                </div>
                { ready && configurationsEnabled && state.id && <ConfigurationsModule open={ configurationsOpen } onSetOpen={ setConfigurationsOpen } car={ state.id } api={ api }  /> }

                { ready && anonymousUser && state.id && carsState.currentConfiguration && allowDownload && <div style={{gap:10}} className="d-flex pos-fixed tr-0 z-2 p-1">
                    <div className="hide-m d-flex align-items-center rounded-4" style={{ transition:"all .3s", padding:"0px 6px", background: hd ? "#000000" : "#99999933" }}>
                        <Switch height={20} width={48} offHandleColor={"#999999"} borderRadius={5} onColor={'#000000'} offColor={'#aaaaaa'} onChange={on=>setHd(on)} checked={hd || false} checkedIcon={<h6 style={{
                            fontSize: 13,
                            lineHeight: '20px',
                            paddingLeft: 5,
                            fontWeight: 500,
                            color: "#ffffff"
                        }}>HD</h6>} uncheckedIcon={<h6 style={{
                            fontSize: 13,
                            lineHeight: '20px',
                            paddingLeft: 8,
                            fontWeight: 500,
                            color: "#ffffff66"
                        }}>SD</h6>}/>
                    </div>
                    
                    { sendBuildTo && 
                        <NavLink className="btn btn-black" onClick={ e => e.stopPropagation() } to={ {
                            pathname: "/demo/" + state.id + "/build/send",
                            state: { 
                                window_title: allowDownload,
                                send_to: JSON.parse( JSON.stringify( sendBuildTo ) ),
                                car: JSON.parse( JSON.stringify( state ) ),
                                currentConfiguration: JSON.parse( JSON.stringify( carsState.currentConfiguration ) ) 
                            } 
                        } }>
                            <div className="show-m"><FileArrowDownIcon /></div><span className="hide-m">{ allowDownload }</span>
                        </NavLink>
                        || 
                        <button className="btn btn-black" style={ { gap: 10 } } onClick={ () => {
                            const data = { options: JSON.parse( JSON.stringify( carsState.currentConfiguration ) ) };
                            Object.keys( data.options ).forEach( k => {
                                let v = data.options[ k ];
                                if( Array.isArray( v ) ){
                                    if( v.length > 0 ){
                                        let labels = v.map( a => a.label )
        
                                        data.options[ k ] = {
                                            group_label: v[0].group_label,
                                            test: v[0],
                                            label: labels.join(', ')
                                        }
                                    } else {
                                        delete data.options[ k ];
                                    }
                                }
                            } );
                            if( api ) api.getScreenShot( 1080, 768, 'image/jpeg', ( error, image ) => {
                                data.car = state;
                                data.image = image;
                                createBuildSheet( data ).then( data => {
                                    
                                    downloadFile( data.pdf, 'buildsheet' + Date.now() + '.pdf' )
                                } )
                            } )
                        }}>
                            <span className='h5'><FileArrowDownIcon /></span><span className='hide-m small'>{ allowDownload }</span>
                        </button> 
                    }
                </div> }

                { ready && state.superuser && state.userid && state.id && <UsersModule car={ state.id } currentUser={ state.userid }/> }
                <div className={`overflow-hidden pos-fixed z-2`} style={{opacity : ready ? 1 : 0, transition: 'opacity .1s 1s', height:'100%', pointerEvents:'none'}}>
                    <div className={`h-100 overflow-hidden d-flex align-items-start px-1`} style={{ gap: navigationOpen ? 6 : 0 }}>
                        { state.option_categories && <div className="overflow-y-auto pt-1 pb-1" style={{ pointerEvents:'all', maxHeight:'100%', minWidth: navigationOpen ? 110 : 0, maxWidth: navigationOpen ? 200 : 0, opacity: ready ? 1 : 0, transform:`translateX(${ ready ? 0 : -100 }%)` }}>
                            <div className='d-flex flex-column' style={{gap: 4}}>
                                { state.logo && <div className="px-1 py-1 d-flex flex-column align-items-center" style={{ backgroundColor: colors['background'], borderRadius: 4 }}>
                                    <img style={{width:100, height:38, objectFit:'contain'}} src={`${state.logo}`} />
                                </div> }
                                { state.option_categories.map( category => (
                                    <OptionCategory colors={ colors } key={`option-category-${ category.id }`} { ...category } />
                                ))}
                            </div>
                        </div> }
                        { carsState.selectedGroup && carsState.selectedGroup.options && <div style={ { pointerEvents:'all', display: navigationOpen ? 'block' : 'none', maxHeight:'100%' } } className="pt-1 pb-1 overflow-y-auto align-items-start pos-rel" >
                            <div className="d-flex flex-column" style={{ gap: 4, width:110 }}>
                                {  carsState.selectedGroup.options.map( option => (
                                    <Option group_label={ carsState.selectedGroup.label } group_slug={ carsState.selectedGroup.slug } key={`option-${ option.id }`} { ...option } api={api} />
                                )) }
                            </div>
                        </div> }
                        <div className="pt-1" style={{pointerEvents:'all'}}>
                            <button className="text-hover-admin-accent text-white" style={{ padding:'10px 8px', borderRadius: 3, backgroundColor:'#99999966'}} onClick={ () => {

                                if( carsState.selectedGroup && carsState.selectedGroup.options ){

                                    carsDispatch( { type:'setSelectedCategory', data: null } );

                                } else {

                                    setNavigationOpen( !navigationOpen );
                                }
                            }}>{ navigationOpen ? <TimesIcon /> : <BarsIcon /> }</button>
                        </div>
                    </div>
                </div>
                <div className="cover pos-abs tl-0 z-0">
                    <div className="cover justify-content-center align-items-center" style={{ background: colors['background'], display: ready ? 'none' : 'flex'}} >
                        <div className="text-center" style={{width:"50%"}}>
                            { state.logo && <div className="pb-4 w-100"><img width="200" src={`${state.logo}`} /></div> }
                            <div style={{backgroundColor:colors['accent'], width:'100%', height:2, transition:'opacity 1s .3s'}}>
                                <div style={{backgroundColor:colors['primary'], width:`${ totalLoadProgress }%`, height:'100%', transition:'width .5s'}}></div>
                            </div>
                            <div className="pt-1 d-flex" style={{gap:10, color:"#66666666"}}><h6 className="tiny">loading</h6><h6 className="tiny">{`${ totalLoadProgress }%`}</h6></div>
                        </div>
                    </div>
                    <iframe style={{transition:"opacity .5s", opacity:ready ? 1 : 0, width:'100%', height:'100%', border:"none"}} src="" id="api-frame" allow="autoplay; fullscreen; xr-spatial-tracking" allowFullScreen mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
                </div>
                <div className="pos-fixed cover z-3" style={{display:'none'}} onClick={ e => {

                    if( api ){

                        api.pickFromScreen( [ e.clientX, e.clientY ], function(err, coord) {

                            if (!err) {

                                let _node = { ...carsState.nodesList.find( n => n.instanceID == coord.instanceID ) };

                                console.log( _node )

                                console.log( coord.material )

                                api.highlightMaterial( coord.material )
                            }
                        } );
                    }
                    }}>
                </div>
                { carsState.croppingOptionImage && <div className="cover d-flex align-items-center justify-content-center" style={{ background:'#00000066', position:'absolute', top:0, left:0, zIndex:200 }}>
                    <div style={{position:'relative'}}>
                        <div className="d-flex align-items-center justify-content-center" style={{position:'absolute', zIndex:2, top:0, right:0, gap:6}} >
                            <button className="bg-black text-white d-flex align-items-center justify-content-center" style={{width:30, height:30}} onClick={()=>{
                                carsDispatch({ type:'setCroppingOptionImage', data : null })
                            }}><TimesIcon /></button>
                            <button className="bg-black text-white d-flex align-items-center justify-content-center" style={{width:30, height:30}} onClick={()=>{

                                //create cropped image here
                                let img = new Image();

                                img.onload = function() {

                                    let ctx = crop_canvas_ref.current.getContext( '2d' );

                                    let clip_rect = { 
                                        x : img.width * ( crop.x / 100 ),
                                        y : img.height * ( crop.y / 100 ),
                                        w : img.width * ( crop.width / 100 ),
                                        h : img.height * ( crop.height / 100 )
                                    }

                                    crop_canvas_ref.current.width = clip_rect.w;

                                    crop_canvas_ref.current.height = clip_rect.h;

                                    ctx.drawImage( 
                                        img, 
                                        clip_rect.x, 
                                        clip_rect.y,
                                        clip_rect.w, 
                                        clip_rect.h,
                                        0, 0, 
                                        clip_rect.w, 
                                        clip_rect.h
                                    );

                                    let data = JSON.parse( JSON.stringify( carsState.croppingOptionImage ) );

                                    data.value.imageData = crop_canvas_ref.current.toDataURL();

                                    carsDispatch( { type: 'setSelectedOption', data } );

                                    carsDispatch({ type:'setCroppingOptionImage', data : null })
                                };
                                img.src= carsState.croppingOptionImage.value.imageData;
                            }}><CheckIcon /></button>
                        </div>
                        <ReactCrop aspect={1} crop={ crop } onChange={ (c,pc) => setCrop( pc ) }>
                            <img style={{maxWidth:'80vw', maxHeight:'80vh'}} src={ carsState.croppingOptionImage.value.imageData } />
                        </ReactCrop>
                    </div>
                    <canvas style={{display:'none'}} ref={crop_canvas_ref} />
                </div> }
            </div>
        </AbstractScreen>
    )
}

export default CarDetailScreen;